import { FEATURE, FEATURE_PARAMS, DEBUG_FEATURE, areParamsValid, } from './feature';
// `Object.keys` includes only `string`s in its return value
const FEATURE_TYPES = Object.keys(FEATURE);
const INVALID_TYPE_SYMBOL_REGEX = /[^a-zA-Z0-9]/;
const PARAM_SEPARATOR = '!';
function decodeParams(type, encodedParams) {
    const params = encodedParams
        .slice(0, FEATURE_PARAMS[type].length)
        .map(decodeURIComponent);
    if (!areParamsValid(type, params)) {
        throw new SyntaxError(`[deeplink] Invalid params for ${JSON.stringify(type.toString())} feature type`);
    }
    return params;
}
function getDebugFeature(url) {
    const DEBUG_FEATURE_QUERY_PARAM = 'deeplinkDebugFeature';
    if (!url.searchParams.has('debug') ||
        !url.searchParams.has(DEBUG_FEATURE_QUERY_PARAM)) {
        return null;
    }
    let debugFeatureParams = url.searchParams.get(DEBUG_FEATURE_QUERY_PARAM) || '';
    // some special cases to allow `[]` and `['']` as params,
    // without complicating `decodeParams` with `&deeplinkDebugFeature` quirks
    if (debugFeatureParams === '') {
        return {
            type: DEBUG_FEATURE,
            params: [],
        };
    }
    else if (debugFeatureParams.startsWith(PARAM_SEPARATOR)) {
        debugFeatureParams = debugFeatureParams.slice(PARAM_SEPARATOR.length);
    }
    return {
        type: DEBUG_FEATURE,
        params: decodeParams(DEBUG_FEATURE, debugFeatureParams.split(PARAM_SEPARATOR)),
    };
}
export function parse(urlOrStringifiedFeature) {
    let strFeature;
    if (urlOrStringifiedFeature instanceof URL) {
        strFeature = urlOrStringifiedFeature.searchParams.get('deeplink') || '';
        if (!strFeature) {
            return getDebugFeature(urlOrStringifiedFeature);
        }
    }
    else {
        strFeature = urlOrStringifiedFeature;
    }
    if (!strFeature) {
        throw new SyntaxError(`[deeplink] Unexpected EOF`);
    }
    const [typeUnknownCase, ...encodedParams] = strFeature.split(PARAM_SEPARATOR);
    if (typeUnknownCase.match(INVALID_TYPE_SYMBOL_REGEX)) {
        throw new SyntaxError(`[deeplink] Invalid feature type: ${JSON.stringify(typeUnknownCase)}`);
    }
    const typeLowerCase = typeUnknownCase.toLowerCase();
    const type = FEATURE_TYPES.find((k) => k.toLowerCase() === typeLowerCase);
    if (!type) {
        throw new SyntaxError(`[deeplink] Unknown feature type: ${JSON.stringify(typeUnknownCase)}`);
    }
    return {
        type,
        params: decodeParams(type, encodedParams),
    };
}
export function stringify(feature) {
    const params = feature.params;
    return (feature.type.toLowerCase() +
        (params && params.length
            ? '!' +
                params
                    .map((p) => encodeURIComponent(p).replace(new RegExp(PARAM_SEPARATOR, 'g'), '%21'))
                    .join(PARAM_SEPARATOR)
            : ''));
}
//# sourceMappingURL=serialization.js.map